import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export type RematchPacketMode = "request" | "cancel";


export class PacketOutRematch extends PacketOut {

    private readonly mode: RematchPacketMode;

    constructor(mode: RematchPacketMode) {
        super(OutboundPacketType.REMATCH);
        this.mode = mode;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            mode: this.mode,
        };
    }
}
